import { createReducer, on } from '@ngrx/store';
import { MemberAccess } from 'src/app/models/common/member-access.model';
import { SaleHorse } from 'src/app/models/sales/sale-horse.model';
import { Sale } from 'src/app/models/sales/sales.model';
import { LookupModel } from '../../../models/common/lookup.model';
import { MemberPermissionSale } from '../../../models/sales/membe-permission-sale.model';
import * as Actions from './sales.action';
export interface SaleState {
  sales: Sale[];
  salesLoaded: boolean;
  saleHorses: SaleHorse[];
  saleStatuses: LookupModel[];
  saleHorse: SaleHorse;
  saleHorsesLoaded: boolean;
  salesListError: any;
  saleProfileError: any;
  saleMemberAccess: MemberAccess;
  syncSaleHorse: boolean;
  stautsSaleHorse: boolean;
  saleMemberPermission: MemberPermissionSale[];
  isUpdatedSaleMemberAccess: boolean;
  isSaleStatusesLoaded: boolean;
}

export const initialState: SaleState = {
  sales: [],
  salesLoaded: false,
  saleHorses: [],
  saleHorse: null,
  saleHorsesLoaded: false,
  salesListError: null,
  saleProfileError: null,
  saleMemberAccess: null,
  syncSaleHorse: false,
  stautsSaleHorse: false,
  isUpdatedSaleMemberAccess: false,
  saleMemberPermission: [],
  saleStatuses: [],
  isSaleStatusesLoaded: false,
};

export const saleReducer = createReducer(
  initialState,
  on(Actions.GetSales, (state) => {
    return {
      ...state,
      sales: [],
      salesLoaded: false,
    };
  }),
  on(Actions.SyncTwSaleHorseData, (state) => {
    return {
      ...state,
      syncSaleHorse:false
    };
  }),
  on(Actions.clearSynced, (state) => {
    return {
      ...state,
      syncSaleHorse: false,
      stautsSaleHorse:false
    };
  }),
  on(Actions.SyncTwSaleHorseDataSuccess, (state) => {
    return {
      ...state,
      syncSaleHorse: true
    };
  }),
  on(Actions.GetSaleById, (state) => {
    return {
      ...state,
      sales: [],
      salesLoaded: false,
    };
  }),
  on(Actions.GetSalesSuccess, (state, { sales }): SaleState => {
    return { ...state, sales, salesLoaded: true };
  }),
  on(Actions.GetSaleByIdSuccess, (state, { sale }): SaleState => {
    return {
      ...state,
      sales: [...state.sales.filter((s) => s.saleId !== sale.saleId), sale],
      salesLoaded: true,
    };
  }),
  on(Actions.GetSaleByIdFailure, (state, { err }): SaleState => {
    return {
      ...state,
      saleProfileError: err,
    };
  }),
  on(Actions.GetSaleStatuses, (state, {}) => {
    return {
      ...state,
      saleStatuses: [],
      isSaleStatusesLoaded: false,
    };
  }),
  on(Actions.GetSaleStatusesSuccess, (state, { saleStatuses }) => {
    return {
      ...state,
      saleStatuses: saleStatuses,
      isSaleStatusesLoaded: true,
    };
  }),

  on(Actions.GetSalesFailure, (state, { err }) => {
    return {
      ...state,
      salesListError: err,
      sales: {
        ...state.sales,
      },
    };
  }),
  on(Actions.GetSaleHorses, (state) => {
    return {
      ...state,
      saleHorses: [],
      saleHorsesLoaded: false,
    };
  }),
  on(Actions.GetSaleHorsesSuccess, (state, { saleHorses }): SaleState => {
    return { ...state, saleHorses, saleHorsesLoaded: true };
  }),
  on(Actions.GetSaleHorse, (state) => {
    return {
      ...state,
      saleHorse: null,
      saleHorsesLoaded: false,
    };
  }),
  on(Actions.GetSaleHorseSuccess, (state, { saleHorse }): SaleState => {
    return { ...state, saleHorse, saleHorsesLoaded: true };
  }),
  on(Actions.updateSaleHorseStatusSuccess, (state, { response }): SaleState => {
    return { ...state, stautsSaleHorse: response };
  }),
  on(Actions.UpdateSaleMemberAccessSuccess, (state, { response }): SaleState => {
    return { ...state, isUpdatedSaleMemberAccess: response };
  }),
  on(Actions.ClearSaleMemberAccess, (state, {  }): SaleState => {
    return { ...state, isUpdatedSaleMemberAccess: false, saleMemberPermission:[] };
  }),
  on(Actions.GetSaleMemberAccessSuccess, (state, { response }): SaleState => {
    return { ...state, saleMemberPermission: response };
  }),
  on(
    Actions.AcceptSaleTermsAndConditionsSuccess,
    (state, { saleId }): SaleState => {
      const sales = state.sales.map((s) => {
        const sale = { ...s };
        if (sale.saleId === saleId) {
          sale.isTermsAcceptanceRequired = false;
        }
        return sale;
      });
      return { ...state, sales };
    }
  ),

  on(
    Actions.GetMemberAccessForSaleSuccess,
    (state, { memberAccess }): SaleState => {
      return { ...state, saleMemberAccess: memberAccess };
    }
  ),

  on(Actions.ResetErrorState, (state): SaleState => {
    return { ...state, saleProfileError: null };
  })
);
